export default "__VITE_ASSET__BI41M1HR__"